import { createUseStyles } from 'react-jss';
import { ThemeProps } from '@styles/theme';
import { flex } from '@resources/mixins';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    modal: {
        width: 'min(580px, calc(100vw - 32px))',
        maxHeight: 'calc(100dvh - 50px)',
        fallbacks: { maxHeight: 'calc(100vh - 50px)' },
        overflowY: 'auto',
        borderRadius: 12,
    },

    header: {
        ...flex('row', 'flex-start', 'center'),
        gap: theme.spacing(4),
        marginBottom: theme.spacing(6),
        padding: `${theme.spacing(2)} 0`,
        borderBottom: `1px solid ${theme.colors.grey_lighter}`,
        paddingBottom: theme.spacing(5),
    },

    headerIcon: {
        color: theme.colors.violet_primary,
        fontSize: 36,
    },

    headerText: {},

    title: {
        fontFamily: theme.font.secondary,
        fontSize: 22,
        fontWeight: 'normal',
        color: theme.colors.black,
        margin: 0,
    },

    subtitle: {
        fontSize: 14,
        color: theme.colors.grey_text,
        margin: `${theme.spacing(1)} 0 0`,
    },

    loader: {
        marginLeft: 'auto',
        color: theme.colors.violet_primary,
    },

    devicesContent: {
        minHeight: 240,
    },

    footer: {
        ...flex('row', 'flex-end', 'center'),
        gap: theme.spacing(3),
        marginTop: theme.spacing(8),
        paddingTop: theme.spacing(5),
        borderTop: `1px solid ${theme.colors.grey_lighter}`,
    },
}));
